// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Form, Icon, Container, Divider, Button, Dimmer, Loader, Segment } from 'semantic-ui-react'
import fire from '../config/Fire'

export default class SignUp extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      password: ''
    }
  }

  componentDidMount = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({ loggedIn: true })
      } else {
        this.setState({ loggedIn: false })
      }
    })
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, edit: true })
  }

  signup = () => {
    const { email, password } = this.state
    this.setState({ loading: true })
    fire
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((u) => {
        if (u.user) {
          const { currentUser } = fire.auth()
          let userUnderscore = currentUser.email.replace(/\./g, '_')
          fetch('https://murkstomstag.herokuapp.com/api/v1/signup/', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              userUnderscore: userUnderscore
            })
          })
            .then((response) => {
              if (response.status === 200) {
                this.props.history.push('/onboarding')
              }
            })
            .catch((error) => {
              this.setState({ signupError: error.message, loading: false })
            })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ loading: false, signupError: error.message })
      })
  }

  render () {
    let { signupError, loading, edit } = this.state
    return (
      <Container className='masterdiv'>
        <div className='slavediv centerX' style={{ backgroundColor: 'transparent' }}>
          <div style={{ maxWidth: '420px' }}>
            <div className='center'>
              <h1>— Check out Murkstom —</h1>
              <h3>it’s free!</h3>
            </div>
            {signupError && (
              <Segment padded style={{ color: '#000', backgroundColor: '#E5E1DB' }} className='mtb'>
                <h3>OOPS!</h3>
                <h5>
                  <b>{signupError}</b>
                </h5>
              </Segment>
            )}
            <Segment padded>
              <Form>
                <Form.Input
                  fluid
                  onChange={this.handleChange}
                  placeholder='Email'
                  autoComplete='username'
                  type='email'
                  name='email'
                />
                <Form.Input
                  fluid
                  type='password'
                  onChange={this.handleChange}
                  placeholder='Password'
                  name='password'
                />
                <label>At least 6 characters, but longer is better.</label>

                <div className='mts'>
                  <Button
                    icon
                    type='submit'
                    color='black'
                    negative={signupError}
                    labelPosition='left'
                    onClick={this.signup}
                    disabled={!edit}
                    style={{ backgroundColor: '#000', color: '#fff' }}>
                    <Icon name='sign in' />
                    Sign up
                  </Button>
                </div>
              </Form>
            </Segment>
            <Segment padded>
              <h5>
                By proceeding, I agree to Mursktom's <a href='/terms'> Terms of Service </a> and
                acknowledge that I have read the <a href='/privacy'> Privacy Policy</a>.
              </h5>
              <Divider />
              <p>
                I also agree that Murkstom or its representatives may contact me by email, phone, or
                SMS (including by automated means) at the email address or number I provide,
                including for marketing purposes.
              </p>
            </Segment>
            <br />
            <h5 className='center'>
              Already have an account?{' '}
              <a style={{ color: '#74A3D4' }} href='/login'>
                Find it here
              </a>
            </h5>
            {loading ? (
              <Dimmer active page blurring='default'>
                <Loader active>Creating your app...</Loader>
              </Dimmer>
            ) : null}
          </div>
        </div>
      </Container>
    )
  }
}